<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="row mx-2">
            <div class="col-12 col-md-2 mt-0 mt-md-4">
              <bita-bootbutton
                v-if="!showForm"
                type="primary"
                title="افزودن  نوع بار"
                icon="fas fa-plus-square"
                class="w-100"
                @click.native="statusChangeModalCreate"
              />
            </div>
            <hr />
            <div class="col-12 col-md-2 col-lg-2 mt-4 mt-md-0">
              <bita-input
                type="text"
                name="national_code"
                validation-container-class=""
                input-class="form-control"
                subtitle="بار خود را جستجو نمایید"
                v-model="search.searchName"
                class="w-100"
              />
            </div>
            <div class="col-12 col-md-2  mt-0 mt-md-4">
              <bita-bootbutton
                type="primary"
                title="جستجو"
                icon="fa fa-search"
                class="w-100"
                @click.native="findLoads"
              />
            </div>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :categories="categories"
      :props-user="users"
      modal-id="edit-modal"
      title="ویرایش نوع بار"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :categories="categories"
      :props-user="users"
      modal-id="create-modal"
      title="اضافه کردن نوع بار"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import LoadsForm from "./Form";

export default {
  components: { "form-modal": LoadsForm },
  mounted() {
    if (this.$acl.isSuperAdmin) this.getUsers();
    this.getCategory();
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت نوع بار",
          link: "/loads",
          active: true,
        },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      pageSize: 0,
      currentPage: 0,
      createForm: {},
      showFilters: true,
      search: {},
      searchCollect: {},
      categories: [
        {
          id: 0,
          name: "هیچکدام",
        },
      ],
      users: [],
      updateForm: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          title: "#",
          template: () =>
            this.$getTemplateServerSide(this.pageSize, this.currentPage),
          width: "40px",
        },
        { field: "name", title: "نام", width: "100px" },
        { field: "load_code", title: "کد بار", width: "100px" },
        {
          field: "parent_item",
          title: "دسته بندی",
          template: (e) => (e.parent_item ? e.parent_item.name : " - "),
          width: "100px",
        },
          { 
          title: "وضعیت ebl", 
          width: "70px", 
          template: (e) => this.statusText(e),
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          visible: function(dataItem) {
            return "Jane";
          },
          width: "100px",
        },
      ];
    },
  },
  methods: {
        statusText(e) {
      let color = e.check_ebl ? '#60e95f' : '#FF0000';
      let text = e.check_ebl ? 'فعال' : 'غیرفعال';
      return `<span class='label' style="color:white;background-color:${color}">${text}</span>`;
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `loads?include=parentItem,owner&page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.search, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      this.$toggleModal("#edit-modal");
    },
    statusChangeModalCreate() {
      this.$toggleModal("#create-modal");
    },
    edit(e) {
      this.isLoadingModal = true;
      let load = this.$refs.grid.getSelectedGridRow(e);
      let _this = this;
      setTimeout(function() {
        _this.updateForm = {
          id: load.id,
          name: load.name,
          load_code: load.load_code,
          check_ebl: load.check_ebl,
          parent_id: load.parent_item ? load.parent_item.id : 0,
          owner_id: collect(load.owner)
            .pluck("id")
            .whereNotNull()
            .toArray(),
        };
        _this.isLoadingModal = false;
      }, 500);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let load = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${load.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `loads/${load.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "loads", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.createForm = {};

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
          this.getCategory();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `loads/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {};

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getCategory() {
      this.$persistClient("get", `loads?filter[parentItem]=0`)
        .then((res) => {
          this.categories = [
            {
              id: 0,
              name: "هیچکدام",
            },
          ];

          for (var i = 0; i < res.data.length; i++) {
            this.categories.push(res.data[i]);
          }
        })
        .finally(() => {});
    },
    findLoads(e) {
      this.loadData();
    },
    getUsers() {
      this.$persistClient("get", "users?include=model&filter[type]=owner").then(
        (res) => {
          this.users = res.data;
        }
      );
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
